module.exports = __webpack_public_path__ + "static/media/general-airflow.2de95885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/general-airflow.jpg
// module id = 144
// module chunks = 0